/**
 * 配置文件枚举翻译 - 中文
 * 包含：merchantWorkbench 配置、assetTypes 配置中的所有枚举标签
 */
export default {
  config: {
    // ==================== assetTypes 配置 ====================
    assetType: {
      shop: '铺位',
      advertising: '广告位',
      sharedSpace: '共享空间',
      warehouse: '仓库',
      parking: '车位',
      officeSpace: '写字间',
    },
    assetStatus: {
      available: '可租',
      rented: '已租',
      maintenance: '维修中',
      reserved: '预留',
      split: '已拆分',
      merged: '已合并',
    },
    advertisingType: {
      indoor: '室内',
      outdoor: '室外',
      elevator: '电梯',
      commonArea: '公共区域',
    },
    displayType: {
      static: '静态',
      digital: '数字',
      led: 'LED屏',
    },
    sharedSpaceType: {
      activity: '活动区',
      exhibition: '展示区',
      corridor: '连廊',
      other: '其他',
    },
    storageType: {
      normal: '常温',
      refrigerated: '冷藏',
      frozen: '冷冻',
    },
    parkingType: {
      normal: '普通',
      disabled: '无障碍',
      vip: '贵宾',
      electric: '充电',
    },
    officeSpaceType: {
      standard: '标准间',
      openPlan: '开放式',
      suite: '套间',
    },
    shopType: {
      retail: '零售',
      food: '餐饮',
      entertainment: '娱乐',
      service: '服务',
    },
    buildingType: {
      mall: '商场',
      office: '写字楼',
      residential: '住宅',
      hotel: '酒店',
      other: '其他',
    },
    businessType: {
      retail: '零售',
      food: '餐饮',
      entertainment: '娱乐',
      service: '服务',
      mixed: '综合',
    },

    // ==================== merchantWorkbench 图层配置 ====================
    layer: {
      basic: '基础信息',
      analytics: '数据分析',
      progress: '招商进度',
      operation: '经营状况',
    },
    layerDescription: {
      basic: '显示资产的基本状态（在租/空置/预留/维修）',
      analytics: '展示招商统计图表（签约率、业态分布、出租率等）',
      progress: '显示招商执行进度（独立于铺位状态，跟踪招商业务流程）',
      operation: '显示已入驻商户的经营数据（预留功能）',
    },
    // 基础信息图层颜色
    basicStatus: {
      rented: '已出租',
      rentedDesc: '资产当前已租出',
      available: '空置',
      availableDesc: '资产当前空置可租',
      reserved: '预留',
      reservedDesc: '资产已预留',
      maintenance: '维修',
      maintenanceDesc: '资产维修中',
    },
    // 招商规划图层颜色
    planningType: {
      retail: '零售',
      retailDesc: '零售业态',
      food: '餐饮',
      foodDesc: '餐饮业态',
      entertainment: '娱乐',
      entertainmentDesc: '娱乐业态',
      service: '服务',
      serviceDesc: '服务业态',
      none: '未规划',
      noneDesc: '尚未进行业态规划',
    },
    // 招商进度图层颜色
    progressStatus: {
      entered: '已开业',
      enteredDesc: '商户已开业运营（招商流程完结）',
      renovating: '装修中',
      renovatingDesc: '商户正在装修（已签约，装修进行中）',
      signed: '已签约',
      signedDesc: '合同已签署，待商户入驻',
      active: '意向中',
      activeDesc: '已达成招商意向，待签约',
      negotiating: '洽谈中',
      negotiatingDesc: '有洽谈记录，正在与商户接触',
      reserved: '预留',
      reservedDesc: '资产已预留，暂不招商',
      maintenance: '维修中',
      maintenanceDesc: '资产维修中，暂不可招商',
      vacant: '待招商',
      vacantDesc: '空置，无任何招商活动记录',
    },
    // 经营状况图层颜色
    operationStatus: {
      reserved: '预留',
      reservedDesc: '功能暂未实现',
    },

    // ==================== 生命周期阶段 ====================
    lifecycle: {
      businessPlan: '模拟落位',
      businessPlanDesc: '品牌模拟落位',
      policySetting: '招商政策制定',
      policySettingDesc: '制定铺位招商政策',
      negotiation: '招商洽谈',
      negotiationDesc: '商户洽谈沟通',
      intention: '招商意向',
      intentionDesc: '确认招商意向',
      formalPlacement: '正式落位',
      formalPlacementDesc: '确认意向后正式落位',
      contractSigned: '正式签约',
      contractSignedDesc: '正式签约完成',
    },
    // 生命周期操作按钮
    lifecycleAction: {
      setBusinessType: '设置业态',
      setPolicy: '设置政策',
      addNegotiation: '新增洽谈',
      createIntention: '创建意向',
      createContract: '创建合同',
      createPlacement: '发起落位',
    },

    // ==================== 右键菜单 ====================
    contextMenu: {
      setBusinessType: '设置业态规划',
      setPolicy: '设置招商政策',
      addNegotiation: '新增洽谈记录',
      createIntention: '创建招商意向',
      createContract: '创建合同',
      cancelIntention: '取消意向',
      viewContract: '查看合同',
      merchantEnter: '商户进场',
      merchantExit: '商户退场',
      viewRenovation: '装修管理',
      viewPlacement: '模拟落位',
      viewBusinessPlan: '业态规划',
    },

    // 审批进行中提示
    approvalPendingTip: '审批进行中，请等待审批结果',
  },
}
